<template>
      <div class="locationCreate">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'location', params: {} }">
          Location
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'locationCreate', params: {} }">
            Create Location
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Create Location</v-card-title>
          <v-card-text>
            <location-form></location-form>
          </v-card-text>
        </v-card>
      </div>
    </template>
    <script>
    import LocationForm from './LocationForm.vue';

    export default {
      name: 'location',
      components: {
        LocationForm
      },
      created() {
        this.$emit("showParent", false);
      }
    }
    </script>
    